/*
 * SubmitError Messages
 *
 * This contains all the text for the SubmitError component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  message: {
    id: 'app.components.SubmitError.message',
    defaultMessage:
      'Saving failed, or the connection dropped before the result came back. Check whether it was saved before you try again.',
  },
});
